// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Майно» (Assets, ключ `asset`, група `office`). */
export const assetsManifest: IModuleManifest = {
  key: 'asset',
  group: 'office',
  slug: 'assets',
  prefix: 'AST',
  name: { en: 'Assets', uk: 'Майно' },
  entities: [
    { key: 'asset', slug: 'asset', name: { en: 'Assets', uk: 'Майно' }, main: true },
    { key: 'asset_holder', slug: 'asset-holder', name: { en: 'Asset Holders', uk: 'Утримувачі' }, main: false },
    { key: 'asset_handover', slug: 'asset-handover', name: { en: 'Asset Handovers', uk: 'Передачі' }, main: false },
    { key: 'asset_repair', slug: 'asset-repair', name: { en: 'Asset Repairs', uk: 'Ремонти' }, main: false },
    { key: 'asset_inventory_check', slug: 'asset-inventory-check', name: { en: 'Asset Inventory Checks', uk: 'Інвентаризації' }, main: false },
    { key: 'asset_status', slug: 'asset-status', name: { en: 'Asset Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/assetsSlice').then((m) => m.assetsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
